export class AuctionDashboard {
  activeAuctions: number;
  lastUpdateActiveAuctions: Date;

  registeredTeachers: number;
  lastUpdateRegisteredTeachers: Date;

  classesFilled: number;
  lastUpdateClassesFilled: Date;

  averageBids: number;
  lastUpdateAverageBids: Date;

  constructor(contentResponse: any) {
    this.activeAuctions = parseInt(contentResponse.activeAuctions);
    this.lastUpdateActiveAuctions = new Date(
      contentResponse.lastUpdateActiveAuctions
    );

    this.registeredTeachers = parseInt(contentResponse.registeredTeachers);
    this.lastUpdateRegisteredTeachers = new Date(
      contentResponse.lastUpdateRegisteredTeachers
    );

    this.classesFilled = parseInt(contentResponse.classesFilled);
    this.lastUpdateClassesFilled = new Date(
      contentResponse.lastUpdateClassesFilled
    );

    this.averageBids = parseInt(contentResponse.averageBids);
    this.lastUpdateAverageBids = new Date(
      contentResponse.lastUpdateAverageBids
    );
  }
}
